import httpService from "@/services/httpService";
import {baseUrl} from "@/config"


const endpoint = baseUrl + "/Enterprise"

const getEnterpriseOrganizations = async (includeParentOrg) => {
    try {
        return await httpService.post(endpoint + '/GetEnterpriseOrganizations', {includeParentOrg} )
    } catch (e) {
    }
}

const getTestVolumeReport = async (startDate, endDate) => {
    try {
        return await httpService.post(endpoint + '/GetTestVolumeReport', {startDate, endDate} )
    } catch (e) {
    }
}

const getEnterprisePreferences = async () => {
    try {
        return await httpService.post(endpoint + '/GetEnterprisePreferences' )
    } catch (e) {
    }
}

const updateEnterprisePreferences = async (prefs) => {
    try {
        return await httpService.post(endpoint + '/UpdateEnterprisePreferences', prefs )
    } catch (e) {
    }
}

const getParentEnterprisePreferences = async () => {
    try {
        return await httpService.post(endpoint + '/GetParentEnterprisePreferences' )
    } catch (e) {
    }
}

export {
    getEnterpriseOrganizations,
    getTestVolumeReport,
    getEnterprisePreferences,
    updateEnterprisePreferences,
    getParentEnterprisePreferences
}
